import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IGetItemsParams } from '../../../httpClient/serverApi/types/IGetItemsParams';
import { IGetItemsResult } from '../../../httpClient/serverApi/types/IGetItemsResult';
import { INamedItem } from '../../../spacesPlatform/models/resourceParts';
import { IUser } from '../../../userManagement/users/serverApi/types/IUser';
import { ILens } from '../types/ILens';

export interface IGetLensesParams extends IGetItemsParams {
}

export interface IGetLensesResult extends IGetItemsResult {
  lenses?: ILens[];
  users?: IUser[];
  projects?: INamedItem[];
  favorites?: string[];
}

export class GetLensesRequest extends Request<IGetLensesParams, IGetLensesResult> {
  constructor(params: IGetLensesParams) {
    super('getLenses', params);
  }
}
